import { lazyForPaint } from 'react-loosely-lazy';
export const LazyVendorResponseEditor = lazyForPaint(() => import(/* webpackPrefetch: true, webpackChunkName: "chunk-Vendor-response-editor" */'./VendorResponseEditor'));
export { VendorResponseEditorSkeleton } from './VendorResponseEditorSkeleton';